import { render, staticRenderFns } from "./agent_config.vue?vue&type=template&id=3668961c&scoped=true"
import script from "./agent_config.vue?vue&type=script&lang=ts"
export * from "./agent_config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668961c",
  null
  
)

export default component.exports